import isEmpty from 'lodash/isEmpty';
import kebabCase from 'lodash/kebabCase';
import lowerCase from 'lodash/lowerCase';
import compact from 'lodash/compact';

// Types
type QueryObjectType = {
  [key: string]: string;
};

type EncodedAddressType = {
  address: string | null;
  unit: string;
};

type DecodedAddressType = {
  pathname: string;
  unit: string;
};

type DecodedAddressReturnType = {
  name: string;
  unit: string;
};

export const encodeFullAddressForUrl = (
  { address = '', unit = '' }: EncodedAddressType = <EncodedAddressType>{},
): string => {
  if (!address) {
    return '';
  }

  const regex = /[!"#$%&'()*+,-./:;<=>?@[\]^_`{|}~]/g;
  const cleanAddress = address.replace(regex, '');
  const cleanUnit = unit.replace(regex, '').trim();

  if (cleanUnit) {
    return encodeURIComponent(kebabCase(cleanAddress)) + '/?unit=' + cleanUnit;
  }

  return encodeURIComponent(kebabCase(cleanAddress)) + '/';
};

export const decodeFullAddressFromUrl = (
  { pathname = '', unit = '' }: DecodedAddressType = <DecodedAddressType>{},
): DecodedAddressReturnType => {
  if (!pathname) {
    return {
      name: '',
      unit: '',
    };
  }
  const splitPath = compact(pathname.split('/'));
  const rawAddress = splitPath[splitPath.length - 1];
  const cleanAddress = lowerCase(rawAddress);

  return {
    name: decodeURIComponent(cleanAddress),
    unit: decodeURIComponent(unit),
  };
};

export const decodeResourceIdFromUrl = (pathname: string): string => {
  const tokens = pathname.split('/');
  if (tokens.length < 4) {
    return '';
  }
  return tokens[3];
};

export const queryObjectToQueryString = (queryObject: QueryObjectType): string => {
  if (!queryObject || isEmpty(queryObject)) {
    return '';
  }

  return (
    '?' +
    Object.keys(queryObject)
      .map((key) => key + '=' + queryObject[key])
      .join('&')
  );
};

export const queryStringToQueryObject = (queryString: string = ''): QueryObjectType => {
  if (!queryString) {
    return {};
  }
  const decodedQueryString: string = decodeURIComponent(queryString);
  const regex = /[?]/g;
  const queryParams = decodedQueryString.replace(regex, '').split('&');
  const queryObject: QueryObjectType = {};

  for (let i = 0; i < queryParams.length; i++) {
    const curr = queryParams[i];
    const [key, val] = curr.split('=');
    const hasHyphen = val.split('-').length > 1;

    if (hasHyphen) {
      const vals = val.split('-').join(',');
      queryObject[key] = vals;
    } else {
      queryObject[key] = val;
    }
  }

  return queryObject;
};
